import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  OnInit,
  TrackByFunction,
  inject
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CaseType } from "@vp/models";
import { Observable } from "rxjs";
import { OverrideModel, OverrideViewModel } from "../edit-service-cost.service";

export interface OverrideFormDialogData {
  allCaseTypes: Observable<CaseType[]>;
  override: OverrideViewModel;
  mode: "edit" | "create";
}

@Component({
  selector: "vp-add-opinion-form",
  templateUrl: "./add-opinion-form.component.html",
  styleUrls: ["./add-opinion-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AddOpinionFormComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<AddOpinionFormComponent>>(MatDialogRef);
  data = inject<OverrideFormDialogData>(MAT_DIALOG_DATA);
  private readonly fb = inject(UntypedFormBuilder);

  form!: UntypedFormGroup;
  originalClose;

  constructor() {
    // Add confirm close logic to dialog to centralize
    this.originalClose = this.dialogRef.close;
    this.dialogRef.close = this.confirmClose.bind(this);
  }

  @HostListener("window:keyup.esc") onKeyUp() {
    this.confirmClose({ save: false });
  }

  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    event.returnValue = false;
  }

  ngOnInit(): void {
    this.form = this.getForm(this.data.override);
    if (this.data.mode === "edit") {
      this.form.get("caseTypeId")?.disable();
    }
  }

  // Satisfies template-use-track-by-function
  trackByFn: TrackByFunction<CaseType> = (_index: number, item: CaseType) => item.caseTypeId;

  confirmClose(result: { save?: boolean }) {
    if (result.save && this.form.valid) {
      const formValue = this.form.getRawValue();
      this.originalClose.bind(this.dialogRef)(new OverrideModel(formValue.caseTypeId, []));
    } else {
      if (this.form.pristine || this.form.invalid) {
        this.originalClose.bind(this.dialogRef)();
      } else {
        if (confirm("Are you sure you want to cancel and potentially lose data?")) {
          this.originalClose.bind(this.dialogRef)();
        }
      }
    }
  }

  private getForm(override: OverrideModel) {
    return this.fb.group({
      caseTypeId: [override.caseTypeId]
    });
  }
}
